;(function() {
  'use strict'

  Controller.$inject = ["$timeout", "projectTrackerService", "imageService"];
  angular.module('app.core').component('projectTrackerEditor', {
    controller: Controller,
    templateUrl: 'project-tracker-editor.html',
    bindings: {
      originalTracker: '<tracker',
      projectId: '<',
      onCancel: '&',
      onSaved: '&',
    },
  })

  var MAX_TRACKER_FILE_SIZE = 299999000 // Keep encoded request under backend limit.

  /* @ngInject */
  function Controller($timeout, projectTrackerService, imageService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.save = save
    ctrl.setImage = setImage
    ctrl.setFile = setFile
    ctrl.setFileError = setFileError

    function onInit() {
      ctrl.tracker = ctrl.originalTracker.clone()
      ctrl.maxFileSizeBytes = MAX_TRACKER_FILE_SIZE
      ctrl.fileErrors = []
      ctrl.saveErrors = []
      ctrl.uploadProgress = null
    }

    function save() {
      ctrl.showErrors = true
      ctrl.saveErrors = []

      if (
        !ctrl.tracker.validate() ||
        ctrl.tracker.isSaving ||
        ctrl.isUploadingImage ||
        ctrl.fileErrors.length
      ) {
        return
      }

      projectTrackerService
        .save(ctrl.tracker, ctrl.projectId, {
          onUploadProgress: setUploadProgress,
        })
        .then(function(saved) {
          ctrl.onSaved({ $tracker: saved })
        })
        .catch(function(error) {
          ctrl.saveErrors = [getSaveErrorMessage(error)]
        })
        .finally(function() {
          ctrl.uploadProgress = null
        })
    }

    function setImage(imageData) {
      if (!imageData) {
        ctrl.tracker.imageUrl = null
        return
      }
      ctrl.isUploadingImage = true
      imageService
        .create(imageData)
        .then(function(imageUrl) {
          ctrl.tracker.imageUrl = imageUrl
        })
        .finally(function() {
          ctrl.isUploadingImage = false
        })
    }

    function setFile(files) {
      var file = files && files[0]
      if (!file) return

      if (file.size > MAX_TRACKER_FILE_SIZE) {
        setFileError({ name: file.name })
        return
      }

      ctrl.fileErrors = []
      ctrl.saveErrors = []
      ctrl.tracker.fileData = file.data
      ctrl.tracker.fileName = file.name
    }

    function setFileError(error) {
      ctrl.saveErrors = []
      ctrl.fileErrors = [
        (error && error.name ? error.name + ' is too large. ' : '') +
          'Tracker HTML files must be under 300MB.',
      ]
    }

    function setUploadProgress(progress) {
      $timeout(function() {
        ctrl.uploadProgress = progress
      })
    }

    function getSaveErrorMessage(error) {
      return (
        (error && error.message) ||
        (error && error.data && error.data.message) ||
        'Tracker could not be saved. Please try again.'
      )
    }
  }
})()
